import { effect, frame } from './move-types'
import type { Move } from './move-types'

export const stageMoves = {
  companion_invite: {
    label: 'Companion invitation',
    description: 'Notice, react, invite, and settle within a small character stage.',
    duration: 2.4,
    expression: 'curious',
    frames: [
      frame(0),
      frame(0.16, { yaw: -0.08, pitch: 0.04, stretch: -0.035 }),
      frame(0.35, { yaw: 0.12, roll: -0.06, stretch: 0.055, y: 0.015 }),
      frame(0.65, { yaw: 0.07, pitch: -0.04, stretch: 0.015 }),
      frame(0.88, { stretch: -0.01 }),
      frame(1),
    ],
  },
  little_orbit: {
    label: 'Little orbit',
    duration: 2.1,
    expression: 'relaxed',
    description:
      'Lift into a small oval, drift right and around, then float home with a soft landing.',
    frames: [
      frame(0),
      frame(0.12, { stretch: -0.06 }),
      frame(0.3, { x: 0.08, y: 0.075, z: 0.035, yaw: -0.16, roll: -0.12 }),
      frame(0.5, { y: 0.12, z: -0.035, yaw: 0.12, roll: 0.06 }),
      frame(0.7, { x: -0.08, y: 0.065, z: 0.025, yaw: 0.16, roll: 0.12 }),
      frame(0.88, { stretch: -0.04 }),
      frame(1),
    ],
  },
  tiptoe_peek: {
    label: 'Tiptoe peek',
    expressions: [
      [0, 'attentive'],
      [0.2, 'curious'],
      [0.75, 'attentive'],
    ],
    duration: 2.3,
    expression: 'curious',
    description:
      'Compress, stretch taller on tiptoe, peek forward, then sink back with a tiny bounce.',
    frames: [
      frame(0),
      frame(0.15, { stretch: -0.065 }),
      frame(0.4, { stretch: 0.16, pitch: -0.075, yaw: -0.13 }),
      frame(0.65, { stretch: 0.14, pitch: -0.055, yaw: 0.08 }),
      frame(0.84, { stretch: -0.055 }),
      frame(1),
    ],
  },
  soft_pirouette: {
    label: 'Soft pirouette',
    duration: 2.1,
    expression: 'relaxed',
    description: 'Wind up, rise slightly, turn a full 360°, then cushion the landing.',
    frames: [
      frame(0),
      frame(0.14, { yaw: -0.22, stretch: -0.075, roll: -0.035 }),
      frame(0.35, { yaw: 1.3, y: 0.09, stretch: 0.04 }),
      frame(0.58, { yaw: 4.3, y: 0.115, roll: 0.04 }),
      frame(0.8, { yaw: Math.PI * 2, y: 0.015 }),
      frame(0.9, { yaw: Math.PI * 2, stretch: -0.055 }),
      frame(1, { yaw: Math.PI * 2 }),
    ],
  },
  happy_squeeze: {
    label: 'Happy squeeze',
    expressions: [
      [0, 'amused'],
      [0.2, 'delighted'],
      [0.8, 'confident'],
    ],
    duration: 1.7,
    expression: 'delighted',
    description: 'Squash into a wide happy bean, hold the grin, then spring taller and settle.',
    frames: [
      frame(0),
      frame(0.22, { stretch: -0.23, roll: 0.035 }),
      frame(0.43, { stretch: -0.25, roll: -0.025 }),
      frame(0.66, { stretch: 0.075, y: 0.025 }),
      frame(0.84, { stretch: -0.035 }),
      frame(1),
    ],
  },
  weightless_pause: {
    label: 'Weightless pause',
    duration: 2.3,
    expression: 'surprised',
    description:
      'Rise softly, hang almost still in the air, then drift down into a gentle landing.',
    frames: [
      frame(0),
      frame(0.12, { stretch: -0.045 }),
      frame(0.35, { y: 0.13, stretch: 0.035, roll: -0.025 }),
      frame(0.64, { y: 0.14, roll: 0.025 }),
      frame(0.88, { stretch: -0.045 }),
      frame(1),
    ],
  },
  tiny_bow: {
    label: 'Tiny bow',
    duration: 1.9,
    expression: 'delighted',
    description: 'Lean forward with smiling eyes, dip in a small thank-you bow, and lift back up.',
    frames: [
      frame(0),
      frame(0.18, { pitch: -0.045 }),
      frame(0.46, { pitch: 0.26, stretch: -0.07, roll: -0.07, z: 0.025 }),
      frame(0.62, { pitch: 0.24, stretch: -0.055, roll: -0.06 }),
      frame(0.83, { pitch: -0.045, stretch: 0.025 }),
      frame(1),
    ],
  },
} satisfies Record<string, Move>
